<template>
  <div>
    <section class="card shadow">
      <b-card class="promocoes">
        <p>teste</p>
      </b-card>
    </section>
  </div>
</template>
<script>
  export default {
    data () {
    }
  }
</script>
<style scoped>
  .promocoes {
    background-color: #77777714;
  }
</style>



// WEBPACK FOOTER //
// src/components/items/PromocoesVue.vue